import { useAuth } from "@/context/AuthContext";

/**
 * Returns true if the current user has the given module permission.
 * Admin always returns true.
 */
export function usePermission(module) {
  const { user } = useAuth();
  if (!user) return false;
  if (user.role === "admin") return true;
  const perms = user.permissions || [];
  return perms.includes(module);
}

export function useHasAny(modules) {
  const { user } = useAuth();
  if (!user) return false;
  if (user.role === "admin") return true;
  const perms = user.permissions || [];
  return modules.some((m) => perms.includes(m));
}
